(() => {
  if (customElements.get('bb-product-experience')) return;
  class ProductExperience extends HTMLElement {
    connectedCallback() {
      if (!this.classList.contains('bbp') || this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.gallery = this.querySelector('swiper-container[id^="gallery-main-product-"]');
      this.thumbnails = [...this.querySelectorAll('[data-bbp-media]')];
      this.dialog = this.querySelector('.bbp-zoom');
      const syncGallery = () => this.syncGallery();
      this.gallery?.addEventListener('swiperinit', syncGallery, { signal });
      this.gallery?.addEventListener('swiperslidechange', syncGallery, { signal });
      window.addEventListener('load', syncGallery, { signal, once: true });
      this.thumbnails.forEach(button => button.addEventListener('click', () => {
        const swiper = this.gallery?.swiper;
        if (!swiper?.initialized) return;
        const index = [...swiper.slides].findIndex(slide => slide.dataset.id === button.dataset.bbpMedia);
        if (index >= 0) swiper.slideTo(index);
      }, { signal }));
      this.querySelectorAll('[data-bbp-step]').forEach(button => button.addEventListener('click', () => {
        const swiper = this.gallery?.swiper;
        if (!swiper?.initialized) return;
        Number(button.dataset.bbpStep) < 0 ? swiper.slidePrev() : swiper.slideNext();
      }, { signal }));
      this.querySelector('[data-bbp-zoom]')?.addEventListener('click', () => this.zoom(), { signal });
      this.gallery?.addEventListener('click', event => {
        if (event.target.closest('figure')?.querySelector('img')) this.zoom();
      }, { signal });
      this.querySelector('[data-bbp-close]')?.addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog?.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, { signal });
      this.dialog?.addEventListener('close', () => this.zoomTrigger?.focus({ preventScroll: true }), { signal });
      const bar = this.querySelector('[data-bbp-buy-bar]');
      const buy = this.querySelector('.main-product__add-to-cart');
      if (bar && buy) {
        const syncBar = () => { bar.hidden = buy.getBoundingClientRect().bottom >= 0; };
        this.buyObserver = new IntersectionObserver(syncBar);
        this.buyObserver.observe(buy);
        window.addEventListener('scroll', () => {
          if (this.barFrame) return;
          this.barFrame = requestAnimationFrame(() => { this.barFrame = null; syncBar(); });
        }, { signal, passive: true });
        window.addEventListener('resize', syncBar, { signal, passive: true });
        syncBar();
        this.querySelector('[data-bbp-return]').addEventListener('click', () => {
          const target = this.querySelector('.main-product__variant-selector') || buy;
          const header = document.querySelector('#nav-wrapper');
          const top = target.getBoundingClientRect().top + window.scrollY - (getComputedStyle(header).position === 'sticky' ? header.offsetHeight : 0) - 18;
          window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          const control = target.querySelector('input:checked,select,button,a');
          control?.focus({ preventScroll: true });
        }, { signal });
        const price = this.querySelector('.main-product__price');
        const syncPrice = () => {
          const value = price?.querySelector('.price--on-sale .price-item--sale, .price:not(.price--on-sale) .price__regular .price-item--regular');
          if (value) this.querySelector('[data-bbp-bar-price]').textContent = value.textContent.trim();
        };
        if (price) {
          this.priceObserver = new MutationObserver(syncPrice);
          this.priceObserver.observe(price, { childList: true, subtree: true, characterData: true });
          syncPrice();
        }
      }
      this.syncGallery();
    }
    syncGallery() {
      const swiper = this.gallery?.swiper;
      if (!swiper?.initialized) return;
      const slide = swiper.slides[swiper.activeIndex];
      if (!slide) return;
      this.thumbnails.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bbpMedia === slide.dataset.id)));
      const active = this.thumbnails.find(button => button.dataset.bbpMedia === slide.dataset.id);
      if (active) {
        const strip = active.parentElement;
        const offset = active.offsetLeft - strip.offsetLeft;
        if (offset < strip.scrollLeft || offset + active.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: Math.max(0, offset - strip.clientWidth / 2 + active.offsetWidth / 2), behavior: 'instant' });
      }
      [...swiper.slides].forEach(item => { item.inert = item !== slide; });
      const previous = this.querySelector('[data-bbp-step="-1"]');
      const next = this.querySelector('[data-bbp-step="1"]');
      if (previous) previous.disabled = swiper.isBeginning;
      if (next) next.disabled = swiper.isEnd;
      const zoom = this.querySelector('[data-bbp-zoom]');
      if (zoom) zoom.hidden = !slide.querySelector('figure>img');
    }
    zoom() {
      const swiper = this.gallery?.swiper;
      const slide = swiper?.slides?.[swiper.activeIndex] || this.gallery?.querySelector('swiper-slide');
      const source = slide?.querySelector('figure>img');
      if (!source || !this.dialog || this.dialog.open) return;
      this.zoomTrigger = this.contains(document.activeElement) && document.activeElement !== document.body ? document.activeElement : this.querySelector('[data-bbp-zoom]');
      const img = source.cloneNode();
      img.removeAttribute('class');
      img.removeAttribute('style');
      img.removeAttribute('loading');
      this.dialog.querySelector('[data-bbp-zoom-image]').replaceChildren(img);
      this.dialog.showModal();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.buyObserver?.disconnect();
      this.priceObserver?.disconnect();
      cancelAnimationFrame(this.barFrame);
      this.abort = null;
    }
  }
  customElements.define('bb-product-experience', ProductExperience);
})();
